import { render, staticRenderFns } from "./UpgradeAutomation.vue?vue&type=template&id=64da9478&scoped=true"
import script from "./UpgradeAutomation.vue?vue&type=script&lang=js"
export * from "./UpgradeAutomation.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAutomation.vue?vue&type=style&index=0&id=64da9478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da9478",
  null
  
)

export default component.exports